import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {
  @Input() messageTxt !: string;
  @Input() headerTxt !: string;
  @Input() isMessageModal:boolean=false;
  @Output() isMessageModalVisible=new EventEmitter<boolean>();
  constructor() { }

  ngOnInit(): void {
  }

  cancel():void{
    this.isMessageModal=false;
    this.isMessageModalVisible.emit(this.isMessageModal);
  }
}
